import React from 'react';
import { lazyGettext } from '@eb/lazy-gettext';
import {
    CHECKOUT_WIDGET_A,
    CHECKOUT_WIDGET_B,
    CHECKOUT_WIDGET_D,
    CUSTOM_REGISTRATION,
    CUSTOM_TICKET_OPTIONS,
    DETAILED_ANALYTICS_A,
    DETAILED_ANALYTICS_C,
    HIGH_CONVERSION,
    INCLUDE_ESSENTIALS,
    MARKETING_TOOLS,
    MARKETPLACE,
    RESERVED_SEATING,
    SEAMLESS_CHECKIN,
    UNLIMITED_TICKET_TYPES,
    VIP_EXPERIENCES_A,
} from '../../constants/features';
import {
    AWESOME_INC_U,
    DANCE_411,
    THE_YOGA_EXPO,
} from '../../constants/testimonials';
import {
    DEFAULT_PACKAGES,
    FINE_PRINT_WITH_FIXED_FEE,
    PACKAGE_TWO,
    PER_PAID_TICKET_TEXT,
} from '../../constants/main';
import { STYLE_FILL, STYLE_NEUTRAL } from '@eb/eds-button';

import { AssortmentsProfessionalComplexIllustration } from '@eb/eds-iconography';

export default {
    mainHeader: {
        tabs: DEFAULT_PACKAGES,
        currentIndex: 1,
        imagePath: `${PACKAGE_TWO}/professional-hero-graphic`,
        bgImgHeight: 425,
        heading: lazyGettext('Professional'),
        secondaryHeading: lazyGettext(
            'A powerful solution to boost sales and grow your business.',
        ),
        priceDescription: lazyGettext('Free for free tickets'),
        primaryCTA: lazyGettext('Try Professional'),
        perPaidTicketText: PER_PAID_TICKET_TEXT,
        CTAStyle: STYLE_FILL,
        dataAutomation: 'package-two-main-header',
        pricingCalloutText: lazyGettext('View fee breakdown.'),
        pricingCalloutDescriptionPrimary: lazyGettext(
            'Pass fees on to attendees, pay nothing.',
        ),
        pricingCalloutDescriptionSecondary: lazyGettext(
            'As always, no fees apply for free tickets.',
        ),
    },
    featureListOne: {
        heading: lazyGettext('Reach new audiences and sell more tickets'),
        secondaryHeading: lazyGettext(
            'Eventbrite puts your event in front of the people most likely to buy tickets — whether on our site or others — and turns that interest into sales at industry-leading rates',
        ),
        features: [
            MARKETPLACE,
            CHECKOUT_WIDGET_A,
            HIGH_CONVERSION,
            CUSTOM_TICKET_OPTIONS,
            DETAILED_ANALYTICS_A,
            MARKETING_TOOLS,
        ],
        imagePath: `${PACKAGE_TWO}/audiences--desktop`,
    },
    featureListTwo: {
        //heading: lazyGettext('Simplify operations to scale your business'),
        //features: [CUSTOM_REGISTRATION, INTEGRATIONS_B],
        //imagePath: `${PACKAGE_TWO}/simplify`,
    },
    featureListThree: {
        heading: lazyGettext('Leave a lasting impression'),
        features: [VIP_EXPERIENCES_A, CHECKOUT_WIDGET_D, SEAMLESS_CHECKIN],
        imagePath: `${PACKAGE_TWO}/brand--ticket`,
    },
    testimonials: {
        heading: lazyGettext(
            'Use the platform supporting hundreds of thousands of growing businesses',
        ),
        testimonials: [THE_YOGA_EXPO, DANCE_411, AWESOME_INC_U],
    },
    featuresExpansion: {
        heading: lazyGettext('Features included with Professional'),
        features: [
            INCLUDE_ESSENTIALS,
            CHECKOUT_WIDGET_B,
            DETAILED_ANALYTICS_C,
            RESERVED_SEATING,
            UNLIMITED_TICKET_TYPES,
            CUSTOM_REGISTRATION,
            // PAYOUTS_B,
        ],
        processingFeesFinePrint: FINE_PRINT_WITH_FIXED_FEE,
    },
    bottomBanner: {
        illustration: <AssortmentsProfessionalComplexIllustration />,
        heading: lazyGettext('Eventbrite Professional'),
        secondaryHeading: lazyGettext('Grow your business'),
        CTA: lazyGettext('Try Professional'),
        CTAStyle: STYLE_NEUTRAL,
    },
};
